import React, { useState, useEffect } from 'react';
import { useUserContext } from '../../generic-ui/UserContext';

const MyAccountMenuTitle = React.memo(() => {
  const { thdCustomer, storefront } = useUserContext();
  const { buyerOrg: companyName } = storefront || {};
  const [title, setTitle] = useState('Sign In or Create an Account');

  const greetingType = thdCustomer?.isB2BCustomer ? 'Welcome Back' : 'Hello';

  // Destructure dependencies to avoid inline nested property access in useEffect
  const isLoggedIn = thdCustomer?.isLoggedIn;
  const username = thdCustomer?.username;
  const isB2BCustomer = thdCustomer?.isB2BCustomer;

  useEffect(() => {
    if (storefront) {
      const greeting = 'Welcome Back';
      if (companyName) {
        setTitle(`${greeting}, ${companyName}`);
      } else {
        setTitle(greeting);
      }
      return;
    }

    if (isLoggedIn) {
      if (username && username.toLowerCase() !== 'self') {
        const formattedUsername = username.charAt(0).toUpperCase() + username.slice(1).toLowerCase();
        setTitle(`${greetingType}, ${formattedUsername}`);
      } else {
        setTitle(greetingType);
      }
    }
  }, [isLoggedIn, username, greetingType]);

  return title;
});

MyAccountMenuTitle.displayName = 'MyAccountMenuTitle';

export default MyAccountMenuTitle;
